import { Body, Heading, Toggle, Tooltip } from '@assembly-js/design-system';
import clsx from 'clsx';
import React, { ChangeEvent } from 'react';

type Props = {
  title: string;
  canAddItems: boolean;
  children: React.ReactNode;
  isEditing: boolean;
  onToggleChange: (isChecked: boolean) => void;
  allowToolTipInfo: boolean;
};

export const ProductStoreLineItemCard = ({
  title,
  canAddItems,
  children,
  isEditing,
  onToggleChange,
  allowToolTipInfo,
}: Props) => {
  const handleToggleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    onToggleChange(isChecked);
  };

  return (
    <div>
      <div
        className={clsx('flex items-center justify-between', {
          'opacity-25 pointer-events-none': isEditing,
        })}
      >
        <Heading className="text-xl text-dark-black py-6">{title}</Heading>
        <Tooltip
          position="top"
          disabled={!allowToolTipInfo}
          content={
            <Body size="sm" className="max-w-[288px]">
              Add at least one subscription plan or one-time purchase.
            </Body>
          }
        >
          <div>
            <Toggle
              checked={canAddItems}
              label=""
              onChange={handleToggleChange}
            />
          </div>
        </Tooltip>
      </div>
      {canAddItems ? <div>{children}</div> : null}
    </div>
  );
};
